import type { ElectronContext } from '@mimir/common/context/applicationContext';
import type { LauncherParams } from '../driver-common/launcher-params';
import { defaultDvrConfig, dvrState, type DvrConfig } from './config';
import type { NleAsset } from '@mimir/common/dto/tenantModel';
import { getScriptString } from './script';
import { startLauncher } from '../driver-common/launcher';
import type { Logger } from '@mimir/common/types/logger';
import { invariant } from '@mimir/common/util/invariant';

export const launchStep = (
  applicationContext: ElectronContext,
  launcherParams: LauncherParams,
  pythonPath: string,
) => {
  const rendererProcess = applicationContext.mainRequire('child_process').execFile(
    launcherParams.encoderExePath,
    launcherParams.encoderExeArgs,
    undefined,
    () => {},
  );
  console.debug(`Started new renderer process: ${rendererProcess.pid}`);
  console.debug(`Starting new Python process ${pythonPath} "${launcherParams.tempScriptFilePath}"`);
  invariant(launcherParams.tempScriptFilePath, 'launcherParams.tempScriptFilePath missing');
  const pythonProcess = applicationContext.mainRequire('child_process').execFile(
    pythonPath,
    [launcherParams.tempScriptFilePath],
    undefined,
    (err: any, stdout: any, stderr: any) => {
      console.debug(`Python(${pythonProcess.pid}): ${JSON.stringify({ err: `${err}`, stdout, stderr })}`);
    }
  );
  console.debug(`Python process: ${pythonProcess.pid}`);

  return rendererProcess;
};

export const launchWithConfig = (
  services: {
    applicationContext: ElectronContext,
    logger: Logger,
    getDownloadPath: () => string,
  },
  dvrConfig: DvrConfig,
) => {
  startLauncher(
    services,
    {
      enabled: dvrConfig.enabled,
      encoderExePath: dvrConfig.dvrPath,
      encoderExeArgs: dvrConfig.headless ? ['-nogui'] : [],
      selectedWatchFolders: dvrConfig.selectedWatchFolders,
      timeout: dvrConfig.timeout || defaultDvrConfig.timeout,
      projectFileExtension: '.drp',
      processName: 'Resolve',
      doesPresetMatch: (presetName: string, preset: NleAsset) => preset.nleType === 'dvr' && (preset.name === presetName || preset.name === `${presetName}.xml`),
      rendererLaunchStep: (applicationContext: ElectronContext, launcherParams: LauncherParams) => launchStep(applicationContext, launcherParams, dvrConfig.pythonPath),
      getScriptString: getScriptString,
      scriptFileExtension: 'py',
    },
    dvrState,
  );
};
